import { autoinject, observable, computedFrom } from 'aurelia-framework';
import { UiActionButton } from "./UiActionButton";

@autoinject()
export class TaskActionService {

    public actionButtons: UiActionButton[] = [];

    public get visibleActionButtons() {
        return this.actionButtons.filter(o => o.visible);
    }

    public addUiActionFromTemplate(template: UiActionButton, additionalOptions?: any): UiActionButton {
        return this.addUiAction(Object.assign({}, template, additionalOptions || {}));
    }

    public addUiAction(options: UiActionButton): UiActionButton {
        var uiAction = new UiActionButton(options);
        var index = this.actionButtons.findIndex(o => o.key == uiAction.key);
        if (index > -1) {
            this.actionButtons.splice(index, 1, uiAction);
        } else {
            this.actionButtons.push(uiAction);
        }

        // add child (dropdown) actions, if any
        uiAction.children = [];
        options.children = options.children || [];
        options.children.forEach(o => {
            uiAction.children.push(new UiActionButton(o));
        });

        return this.actionButtons.find(o => o.key == uiAction.key) as UiActionButton;
    }


    public removeUiAction(key: string) {
        var index = this.actionButtons.findIndex(o => o.key == key);
        if (index > -1) {
            this.actionButtons.splice(index, 1);
        }
    }

    public static saveActionTemplate: UiActionButton = {
        key: "sysverb_save",
        name: "Save",
        visible: true,
        redirectAfterSubmit: true,
        children: [
            {
                key: "sysverb_save",
                name: "Save and Stay",
                visible: true,
                redirectAfterSubmit: false
            }
        ]
    };

    public static closeActionTemplate: UiActionButton = {
        key: "sysverb_close",
        name: "Complete Task",
        performValidation: false,
        visible: true,
        redirectAfterSubmit: true
    };

    public static startWorkActionTemplate: UiActionButton = {
        key: "sysverb_start_work",
        name: "Start Work",
        performValidation: false,
        visible: true,
        redirectAfterSubmit: false
    };
}